import AuthLayout from "./AuthLayout.vue";
import AuthMicrosoftPage from "./pages/AuthMicrosoftPage.vue";

export const authRoutes = {
  path: "/auth",
  component: AuthLayout,
  children: [
    {
      path: "microsoft/redirect/:passport",
      name: "AuthMicrosoftPage",
      component: AuthMicrosoftPage
    },
  ]
}



// WEBPACK FOOTER //
// ./src/features/auth/routes.js